import React from 'react'

const InfoBox = ({combinedData, uniqueStates, onclose}) => {
  return (
	<div>
		{/* <button className="absolute top-0 right-0 px-3 py-1 text-sm font-semibold text-black bg-green-50 rounded-full" onClick={onclose}>
			✖
		</button> */}
		<h3 className="font-bold text-lg mb-4">🗺️ State Spray Coverage</h3>
      {uniqueStates.map(state => {
        const totalArea = combinedData.filter(d => d.state === state).reduce((sum, curr) => {
          const area = parseFloat(curr.area); // or curr.areasprayed
          return sum + (isNaN(area) ? 0 : area);
        }, 0);

        const totalAreaSprayed = combinedData.filter(f => f.droneSprayStatus === 'Completed').reduce((sum, curr) => {
          const area = parseFloat(curr.areasprayed); // or curr.areasprayed
          return sum + (isNaN(area) ? 0 : area);
        }, 0);
        return (
          <div key={state} className="flex justify-between text-sm border-b py-1">
            <span>{state}</span>
            <span>{(totalAreaSprayed*100/totalArea).toFixed(1)}%</span>
          </div>
        );
      })}

	  
	</div>
  )
}

export default InfoBox